import { useModal } from "../../../context/ModalContext"
import { useTableData } from "../../../context/TableDataContext"
import OrderModal from "../../modals/payment-modal/PaymentModal"
import MovementModal from "../../modals/transaction-modal/TransactionModal"
import { TableMovement, TableOrder } from "./data/types"
import { useCallback, useEffect } from "react"

import CustomerModal from "../../modals/customer-modal/CustomerModal"
import { TableCustomer } from "./data/types"

export function TableModals() {
	const {
		selectedItem,
		isModalOpen,
		isClosing,
		setModalOpen,
		setSelectedItem,
		setIsClosing,
	} = useModal()

	const { currentView, updatePayment } = useTableData()

	const handleModalClose = useCallback(() => {
		setIsClosing(true)
		const timeout = setTimeout(() => {
			setIsClosing(false)
			setModalOpen(false)
			setSelectedItem(null)
		}, 300)

		return () => clearTimeout(timeout)
	}, [setIsClosing, setModalOpen, setSelectedItem])

	const handlePaymentUpdate = useCallback(
		(updatedPayment: TableOrder) => {
			updatePayment(updatedPayment)
		},
		[updatePayment]
	)

	useEffect(() => {
		return () => {
			setIsClosing(false)
			setModalOpen(false)
			setSelectedItem(null)
		}
	}, [setIsClosing, setModalOpen, setSelectedItem])

	if (!selectedItem && !isClosing) return null

	switch (currentView) {
		case "orders":
			return (
				<OrderModal
					key={selectedItem?.id}
					open={isModalOpen && !isClosing}
					onClose={handleModalClose}
					payment={selectedItem as TableOrder}
					onPaymentUpdate={handlePaymentUpdate}
				/>
			)
		case "movements":
			return (
				<MovementModal
					open={isModalOpen && !isClosing}
					onClose={handleModalClose}
					transaction={selectedItem as TableMovement}
				/>
			)
		case "customers":
			return (
				<CustomerModal
					open={isModalOpen && !isClosing}
					onClose={handleModalClose}
					customer={selectedItem as TableCustomer}
				/>
			)
		default:
			return null
	}
}
